jQuery(document).ready(function($){
  $('.faq_link').on('click', function(e){
    e.preventDefault();
    $(this).parents('figure').toggleClass('active');
  })
  KlaviyoSubscribe.attachToForms('.klaviyo_embed_form', {
    hide_form_on_success: true,
    success_message: "Thanks for subscribing!",
    extra_properties: {
      $source: window.location.href,
      $method_type: "Klaviyo Form",
      $method_id: 'embed'
    },
    success: function ($form) {

    }
  });

})